<template>
	<div class="tweetCard" v-bind:class="{ 'noImage': !cardImage }">
    <!-- <img src="https://loremflickr.com/320/240/beach?random=" class="img-fluid" /> -->
		<!-- <img :src="cardData.json_object.user.profile_background_image_url" class="img-fluid" /> -->
    <span class="imgWrap" v-if="cardData.json_object.extended_entities"><img :src="cardData.json_object.extended_entities.media[0].media_url_https" class="backgroundBlur"/><img :src="cardData.json_object.extended_entities.media[0].media_url_https" class=" cardImage img-fluid"/></span>
		<div class="cardHeader">
			<img :alt="cardData.json_object.user.description" :src="bgImage"/>
      <div class="content">
  			<p>{{ cardData.json_object.full_text }}
          <small><a rel="noopener" :href="'https://www.twitter.com/'+cardData.json_object.user.screen_name" target="_blank">@{{ cardData.json_object.user.screen_name }}</a> - {{ whenDate }}</small>
        </p>
        <!-- <h3>{{ cardData.json_object.user.name }} </h3> -->
        
      </div>
		</div>
    	<div class="cardActions">
        <a :href="'https://mobile.twitter.com/' + this.cardData.json_object.user.screen_name + '/status/' + this.cardData.json_object.id_str" target="_blank" class="btn btn-default btn-block">View Tweet &rarr;</a>
      </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
      name: 'tweet-card',
      data () {
        return {
          cardImage: false
        }
      },
      props: {
        cardData: {
          type: Object,
          default: null
        }
      },
      computed: {
        bgImage () {
          return this.cardData.json_object.user.profile_image_url_https
        },
        cardImageUrl () {
          return this.cardData.json_object.extended_entities.media[0].media_url_https
        },
        whenDate () {
          return moment(this.cardData.json_object.created_at, 'ddd MMM D HH:mm:ss Z YYYY').fromNow()
        }
      },
      mounted: function () {
        if (this.cardData.json_object.extended_entities != null) {
          this.cardImage = true
        }
      },
      methods: {
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cards/Tweet.vue